import axios from 'axios';
import { store } from '../store';
import Form from 'form-backend-validation';
import { router } from '@inertiajs/vue3'

axios.interceptors.response.use((response) => response, (error) => {
    const statusCode = error.response ? error.response.status : null;

    if (statusCode === 401) {
        location.reload();
    }

    throw error;
});

class AuthService {

    loginMember(email, password, isMobile = false) {
        var url = `/api/member/login`;
        var isSpatieForm = email instanceof Form;
        var request = isSpatieForm ? email.post(url) : axios.post(url, { email: email, password: password, });

        return request
            .then(response => {
                let data = isSpatieForm ? response.data : response.data.data;
                store.dispatch('setUser', data.user);
                store.dispatch('setCity', data.city);

                if (password instanceof Object) {
                    password();
                }

                let user = response.data.user;

                if (user.type === 'client' && !isMobile) {
                    window.location.href = '/kund';
                }
            }).catch(e => {
                console.log(e);
            });

    }

    loginClient(email, password) {
        var url = `/api/client/login`;
        var isSpatieForm = email instanceof Form;
        var request = isSpatieForm ? email.post(url) : axios.post(url, { email: email, password: password, });

        return request
            .then(response => {
                let data = isSpatieForm ? response.data : response.data.data;
                store.dispatch('setUser', data.user);
                store.dispatch('setCity', data.city);

                if (password instanceof Object) {
                    password();
                }
            }).catch(e => {
                console.log(e);
            });
    }

    logout(reload = true) {
        axios.post('/api/site/logout').then(response => {
            router.reload();
        });
    }
}

export default new AuthService();
